var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"chat-session"}},[_c('div',{staticClass:"container"},[_c('h1',[_vm._v("Welcome to the Casey Assistant")]),_vm._m(0),_c('ChatInput')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_c('strong',[_vm._v("Your AI-powered solution for managing cases and analyzing data with ease.")])])
}]

export { render, staticRenderFns }